import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import Catalog from "@/pages/catalog/page";
import ComicDetail from "@/pages/comic/page";
import Ranking from "@/pages/ranking/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "catalog", element: <Catalog /> },
      { path: "comic/:id", element: <ComicDetail /> },
      { path: "ranking", element: <Ranking /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;